import LoadingSVG from '../../../components/svg/Graphics/LoaderGraphic.svg?react';
import { StatusTemplate } from '../StatusTemplate/StatusTemplate';

export function PaymentStatusLoading() {
  return (
    <StatusTemplate>
      <div className="flex h-[20rem] flex-row flex-nowrap">
        <LoadingSVG
          className="h-[16rem] w-full motion-safe:animate-loading-svg-spin"
          data-ocularid="paymentStatusLoading"
        />
        <div className="ml-[-100%] box-border w-full flex-none pt-[7rem] text-center text-[1.5rem]">
          Loading...
        </div>
      </div>
    </StatusTemplate>
  );
}
